"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("@lingui/react");

var _react2 = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactRouterDom = require("react-router-dom");

var _blocks = require("@bueno/blocks");

var _core = require("@lingui/core");

var _i18n = require("../../../i18n");

var _UserMenu = require("./UserMenu.styles");

var _actionCreators = require("../../../redux/modules/auth/actionCreators");

var _locale = require("../../../context/locale");

var _reactRedux = require("react-redux");

const IconExternal = () => {
  return /*#__PURE__*/_react2.default.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none"
  }, /*#__PURE__*/_react2.default.createElement("path", {
    d: "M13 3L16.293 6.293L9.293 13.293L10.707 14.707L17.707 7.707L21 11V3H13Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react2.default.createElement("path", {
    d: "M19 19H5V5H12L10 3H5C3.897 3 3 3.897 3 5V19C3 20.103 3.897 21 5 21H19C20.103 21 21 20.103 21 19V14L19 12V19Z",
    fill: "currentColor"
  }));
};

const IconHelp = () => {
  return /*#__PURE__*/_react2.default.createElement("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react2.default.createElement("path", {
    d: "M12 6C10.957 6.00132 9.95719 6.41622 9.2197 7.1537C8.48222 7.89118 8.06732 8.89104 8.066 9.934H10.066C10.066 8.867 10.934 8 12 8C13.066 8 13.934 8.867 13.934 9.934C13.934 10.532 13.453 10.966 12.718 11.56C12.4779 11.7481 12.2473 11.948 12.027 12.159C11.029 13.156 11 14.215 11 14.333V15H13L12.999 14.367C13 14.351 13.032 13.981 13.44 13.574C13.59 13.424 13.779 13.274 13.975 13.116C14.754 12.485 15.933 11.532 15.933 9.934C15.9322 8.89106 15.5176 7.89104 14.7802 7.15347C14.0429 6.4159 13.0429 6.00106 12 6ZM11 16H13V18H11V16Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react2.default.createElement("path", {
    d: "M12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.589 4 12 4C16.411 4 20 7.589 20 12C20 16.411 16.411 20 12 20Z",
    fill: "currentColor"
  }));
};

function mapDispatchToProps(dispatch) {
  return {
    onLogout: () => dispatch((0, _actionCreators.logout)())
  };
}

const StyledList = (0, _styledComponents.default)(_blocks.ActionList)`
  a {
    text-decoration: none;
  }
`;
const CustomAvatar = (0, _styledComponents.default)(_blocks.Avatar)`
  width: 34px;
  height: 34px;
  background: none;
  /* neutral dark 8 */
  box-shadow: inset 0 0 0 1px hsl(207, 5.6%, 31.6%);
  font-size: 16px;
  font-weight: normal;
`;
const ExternalLinkContent = _styledComponents.default.span`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
`;

const UserMenu = ({
  clientRoutes,
  loggedIn,
  onLogout
}) => {
  const {
    adminLinks,
    userDetails
  } = clientRoutes;
  const {
    locale,
    setLocale
  } = (0, _locale.useLocale)();
  const hasZendeskKey = window.ZENDESK_SHARED_SECRET != null && window.ZENDESK_SHARED_SECRET !== '';
  return /*#__PURE__*/_react2.default.createElement(_UserMenu.$MenuWrapper, null, /*#__PURE__*/_react2.default.createElement(_blocks.Menu, null, ({
    isOpen,
    toggle,
    close
  }) => /*#__PURE__*/_react2.default.createElement(_react2.Fragment, null, /*#__PURE__*/_react2.default.createElement(CustomAvatar, {
    "data-cy": "UserMenu",
    name: userDetails.name,
    onClick: toggle
  }), isOpen && /*#__PURE__*/_react2.default.createElement(_blocks.Popover, {
    right: true
  }, userDetails.name && /*#__PURE__*/_react2.default.createElement(_blocks.ActionHeading, null, /*#__PURE__*/_react2.default.createElement(_react.Trans, {
    id: "user_menu.salutation",
    values: {
      0: userDetails.name
    }
  })), /*#__PURE__*/_react2.default.createElement(StyledList, null, adminLinks.profile && /*#__PURE__*/_react2.default.createElement(_blocks.ActionItemButton, {
    key: adminLinks.profile.href,
    as: "a",
    target: "_blank",
    rel: "noopener",
    onClick: close,
    to: adminLinks.profile.href,
    href: adminLinks.profile.href
  }, /*#__PURE__*/_react2.default.createElement(ExternalLinkContent, null, adminLinks.profile.label(_core.i18n), /*#__PURE__*/_react2.default.createElement(IconExternal, null))), adminLinks.insightSubscriptions && /*#__PURE__*/_react2.default.createElement(_blocks.ActionItemButton, {
    key: adminLinks.insightSubscriptions.href,
    as: "a",
    target: "_blank",
    rel: "noopener",
    onClick: close,
    to: adminLinks.insightSubscriptions.href,
    href: adminLinks.insightSubscriptions.href
  }, /*#__PURE__*/_react2.default.createElement(ExternalLinkContent, null, adminLinks.insightSubscriptions.label(_core.i18n), /*#__PURE__*/_react2.default.createElement(IconExternal, null))), adminLinks.userAdmin && /*#__PURE__*/_react2.default.createElement(_blocks.ActionItemButton, {
    key: adminLinks.userAdmin.href,
    as: _reactRouterDom.Link,
    onClick: close,
    to: adminLinks.userAdmin.href,
    href: adminLinks.userAdmin.href
  }, adminLinks.userAdmin.label(_core.i18n)), adminLinks.siteSettings && /*#__PURE__*/_react2.default.createElement(_blocks.ActionItemButton, {
    key: adminLinks.siteSettings.href,
    as: _reactRouterDom.Link,
    onClick: close,
    to: adminLinks.siteSettings.href,
    href: adminLinks.siteSettings.href
  }, adminLinks.siteSettings.label(_core.i18n)), adminLinks.buenoLabs && /*#__PURE__*/_react2.default.createElement(_blocks.ActionItemButton, {
    key: adminLinks.buenoLabs.href,
    as: "a",
    target: "_blank",
    rel: "noopener",
    onClick: close,
    to: adminLinks.buenoLabs.href,
    href: adminLinks.buenoLabs.href
  }, /*#__PURE__*/_react2.default.createElement(ExternalLinkContent, null, adminLinks.buenoLabs.label(_core.i18n), /*#__PURE__*/_react2.default.createElement(IconExternal, null))), !loggedIn ? /*#__PURE__*/_react2.default.createElement(_blocks.ActionItemButton, {
    as: _reactRouterDom.Link,
    onClick: close,
    to: adminLinks.auth.href,
    href: adminLinks.auth.href
  }, adminLinks.auth.label(_core.i18n)) : /*#__PURE__*/_react2.default.createElement(_blocks.ActionItemButton, {
    onClick: onLogout
  }, adminLinks.auth.label(_core.i18n))), /*#__PURE__*/_react2.default.createElement(_blocks.ActionHeading, null, /*#__PURE__*/_react2.default.createElement(_react.Trans, {
    id: "user_menu.language"
  })), /*#__PURE__*/_react2.default.createElement(StyledList, null, Object.entries(_i18n.locales).map(([key, val]) => /*#__PURE__*/_react2.default.createElement(_blocks.ActionItemButton, {
    key: val,
    onClick: () => {
      setLocale(key);
      close();
    },
    iconRight: _i18n.locales[locale] === val && /*#__PURE__*/_react2.default.createElement(_blocks.CheckSingle, {
      tiny: true
    })
  }, val))), /*#__PURE__*/_react2.default.createElement(_blocks.ActionHeading, {
    style: {
      padding: 0
    }
  }), hasZendeskKey && /*#__PURE__*/_react2.default.createElement(StyledList, null, /*#__PURE__*/_react2.default.createElement(_blocks.ActionItemButton, {
    onClick: () => {
      window.zE('webWidget', 'open');
    },
    iconRight: /*#__PURE__*/_react2.default.createElement(IconHelp, null)
  }, _core.i18n._('user_menu.help')))))));
};

UserMenu.propTypes = {
  loggedIn: _propTypes.default.bool.isRequired,
  clientRoutes: _propTypes.default.shape({
    appLinks: _propTypes.default.arrayOf(_propTypes.default.shape({
      href: _propTypes.default.string,
      label: _propTypes.default.func
    })),
    adminLinks: _propTypes.default.shape({
      support: _propTypes.default.shape({
        href: _propTypes.default.string,
        label: _propTypes.default.func
      })
    }),
    userDetails: _propTypes.default.shape({
      name: _propTypes.default.string,
      initials: _propTypes.default.string
    })
  }).isRequired
};

var _default = (0, _reactRedux.connect)(null, mapDispatchToProps)(UserMenu);

exports.default = _default;
module.exports = exports.default;